module.exports = __webpack_public_path__ + "img/BAU_Partners_17.a2515238.jpg";